module.exports = __webpack_public_path__ + "static/media/alert-red.446f96aa.svg";